var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNautilus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.629 51H11.8145V56.8145L6 56.8145V62.629H11.8145L11.8145 56.8145H17.629V51Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5569 61.2663C23.142 59.8526 23.4436 58.3408 23.4436 56.8145L23.44 56.8181H17.6255C17.6255 57.5813 17.4728 58.3372 17.1821 59.0422C16.8877 59.7472 16.4589 60.3868 15.9211 60.9283C15.3832 61.4698 14.74 61.8949 14.035 62.1893C13.33 62.4837 12.5741 62.6327 11.8109 62.6327V68.4472C13.3409 68.4472 14.8527 68.1455 16.2627 67.5605C17.6727 66.9754 18.9555 66.1177 20.0348 65.0384C21.1142 63.9591 21.9718 62.6763 22.5569 61.2663Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2555 55.3609V64.2934H35.8103V59.1876H37.0858V60.4631H38.3614V61.7387H39.6369V64.2934H42.1917V55.3572H39.6369V59.1876H38.3614V57.912H37.0858V56.6364H35.8103V55.3609H33.2555Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7462 63.0215H43.4707V61.7459H44.7462V60.4704H49.8521V59.1948H44.7462V57.9193H51.1313V59.1948H52.4069V64.3007H44.7462V63.0215ZM46.0218 63.0215H49.8521V61.7459H46.0218V63.0215Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9621 63.0215V64.2971L54.9657 64.3007H62.6264V57.9156H60.0716V63.0215H56.2413V57.9156H53.6865V63.0215H54.9621Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7319 64.2971V59.1912H65.1772V57.9156H67.7319V55.3609H70.2867V57.9156H72.8414V59.1912H70.2867V64.2971H67.7319Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9435 55.3609V56.6364H80.4983V55.3609H77.9435Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3887 63.0215V64.2971H83.053V63.0215H80.4983V57.9156H76.6679V59.1912H77.9435V63.0215H75.3887Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6046 64.2971V63.0215H88.1594V56.6364H86.8838V55.3609H90.7141V63.0215H93.2689V64.2971H85.6046Z",
    fill: "#AAAAB6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8199 63.0215V64.2971L95.8235 64.3007H103.484V57.9156H100.929V63.0215H97.099V57.9156H94.5443V63.0215H95.8199Z",
    fill: "#AAAAB6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.759 64.2971V63.0215H111.144V61.7459H106.039V60.4704H104.763V59.1948H106.039V57.9193H112.424V59.1948H107.318V60.4704H112.424V61.7459H113.699V63.0215H112.424V64.2971H104.759Z",
    fill: "#AAAAB6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.742 63.0215V64.2971H132.847V63.0215H134.123V61.746H131.568V63.0215H129.013V61.746H127.738V57.9156H129.013V56.6401H131.568V57.9156H134.123V56.6401H132.847V55.3645H127.742V56.6401H126.466V57.9156H125.19V61.746H126.466V63.0215H127.742Z",
    fill: "#AAAAB6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.402 64.2971V55.3609H137.957V57.9156H143.063V59.1912H144.338V64.2971H141.784V59.1912H137.953V64.2971H135.402Z",
    fill: "#AAAAB6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.893 63.0215V64.3007H154.553V59.1948H153.278V57.9193H146.893V59.1948H151.999V60.4704H146.893V61.7459H145.617V63.0215H146.893ZM151.999 63.0215H148.168V61.7459H151.999V63.0215Z",
    fill: "#AAAAB6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.663 56.6364V55.3609H162.218V56.6364H159.663Z",
    fill: "#AAAAB6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.109 64.2971V63.0215H159.663V59.1912H158.388V57.9156H162.218V63.0215H164.773V64.2971H157.109Z",
    fill: "#AAAAB6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.045 64.2934V64.2971L166.041 64.2934H166.045Z",
    fill: "#AAAAB6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M166.045 64.2934H168.596V59.1876H172.426V64.2934H174.981V59.1876H173.705V57.912H166.045V64.2934Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNautilus);
export default __webpack_public_path__ + "static/media/nautilus.c7427eee2fdeb1ca8e0666cd80750fed.svg";
export { ForwardRef as ReactComponent };